import { MessageCircle } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

const WHATSAPP_NUMBER = "34669559924"; // LS39 Motos real number

export default function WhatsAppButton() {
    const { t } = useLang();
    const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(t.footer.whatsapp_msg)}`;
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-floating-btn"
            aria-label="WhatsApp LS39"
            className="fixed bottom-6 right-6 z-40 flex items-center gap-2 px-5 py-4 text-sm font-semibold uppercase tracking-[0.2em] text-neutral-900 shadow-2xl transition-all hover:scale-105"
            style={{ background: "#25D366" }}
        >
            <MessageCircle size={18} />
            <span className="hidden sm:inline">WhatsApp</span>
        </a>
    );
}
